
import {CommentLoader as BaseCommentLoader} from '../../../application/comment/commentLoader';
import {Form} from '../../../application/forms/form';
import {Popup} from '../../../application/popup';

class CommentLoader extends BaseCommentLoader
{
    /** @param {Element} loadedElement */
    static afterCommentsLoaded(loadedElement) {
        let formElement = loadedElement.querySelector('[data-comment="form"]'),
            commentAddMoreElement = loadedElement.querySelector('[data-comment="add-more"]'),
            commentForm = new Form(formElement);

        /** @param {ApiResponse} response */
        commentForm.setSuccessCallback(() => {
            if (Popup.hasOpen('offer-view')) {
                Popup.hide('offer-view');
            } else {
                formElement.classList.add('d-none');
                commentAddMoreElement.classList.remove('d-none');
            }
        });

        commentAddMoreElement.querySelector('[data-comment="add-more-button"]').addEventListener('click', (event) => {
            event.preventDefault();

            formElement.classList.remove('d-none');
            commentAddMoreElement.classList.add('d-none');
        });
    }
}

export {CommentLoader};
